var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { display, fontSize, height, lineHeight, space, themeGet, } from 'styled-system';
import { FlexJustifyContent, Grid, GridItem, } from '../../common/components/Grid';
import { LinkStyles } from '../../common/components/Link';
import { LocaleConsumer } from '../../common/providers/LocaleProvider';
import { breakpoint } from '../../common/theme/helper';
import RichTextBlock from '../../common/components/RichText';
var ShowMoreContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ShowMoreContentContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n\n  ", ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      hsla(0, 0%, 100%, 0),\n      hsla(0, 0%, 100%, 0) 30%,\n      #fff\n    );\n    pointer-events: none;\n    z-index: 1;\n\n    ", ";\n  }\n"], ["\n  position: relative;\n  overflow: hidden;\n\n  ", ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      hsla(0, 0%, 100%, 0),\n      hsla(0, 0%, 100%, 0) 30%,\n      #fff\n    );\n    pointer-events: none;\n    z-index: 1;\n\n    ", ";\n  }\n"])), height, display);
var ShowMoreButtonContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, space);
ShowMoreButtonContainer.defaultProps = {
    mt: 3,
};
var ShowMoreButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: none;\n  background: none;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  border: none;\n  background: none;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), LinkStyles, space, lineHeight, fontSize);
ShowMoreButton.defaultProps = {
    styled: true,
    textDecoration: 'underline',
    m: 0,
    p: 0,
    fontSize: 3,
    lineHeight: 3,
};
var StyledRichTextBlock = styled(RichTextBlock)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  // highlighted textBlock\n  p > span.highlighted {\n    display: block;\n    padding: 20px;\n    margin: 10px 0;\n    background-color: ", ";\n\n    ", " {\n      padding: 30px;\n    }\n  }\n"], ["\n  // highlighted textBlock\n  p > span.highlighted {\n    display: block;\n    padding: 20px;\n    margin: 10px 0;\n    background-color: ", ";\n\n    ", " {\n      padding: 30px;\n    }\n  }\n"])), themeGet('colors.gray.4'), breakpoint(2));
var ShowMore = /** @class */ (function (_super) {
    __extends(ShowMore, _super);
    function ShowMore(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { expanded: false };
        return _this;
    }
    ShowMore.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, previewHeight = _a.previewHeight, breakpointsHide = _a.breakpointsHide;
        var expanded = this.state.expanded;
        var containerDisplay = breakpointsHide.map(function (shouldHideContent) { return (shouldHideContent ? 'block' : 'none'); });
        var containerHeight = breakpointsHide.map(function (shouldHideContent) { return (shouldHideContent ? previewHeight : 'auto'); });
        return (React.createElement(ShowMoreContainer, null,
            React.createElement(ShowMoreContentContainer, { height: !expanded ? containerHeight : 'auto', display: !expanded ? containerDisplay : 'none' }, children),
            React.createElement(ShowMoreButtonContainer, { display: containerDisplay },
                React.createElement(LocaleConsumer, null, function (l10n) {
                    var label = expanded
                        ? l10n.t('h24_show_less')
                        : l10n.t('h24_show_more');
                    var sign = expanded ? '-' : '+';
                    return (React.createElement(ShowMoreButton, { "data-testid": "show-more-less-button", onClick: function () {
                            return _this.setState(function (state) { return ({ expanded: !state.expanded }); });
                        } },
                        sign,
                        " ",
                        label));
                }))));
    };
    ShowMore.propTypes = {
        /** Sets the preview height of the children (default: 200) */
        previewHeight: PropTypes.number.isRequired,
        /**
         * An array of booleans, corresponding to the theme breakpoints, that will
         * activate "Show More" button on a special breakpoint when the value is
         * true (default: [true, false, false] - show more is activated only on mobile)
         */
        breakpointsHide: PropTypes.arrayOf(PropTypes.bool).isRequired,
        /** Content to hide behind the "Show More" */
        children: PropTypes.node.isRequired,
    };
    ShowMore.defaultProps = {
        previewHeight: 200,
        breakpointsHide: [true, false, false],
    };
    return ShowMore;
}(React.Component));
var RichTextWithShowMore = function (_a) {
    var html = _a.html, hideContentOnBreakpoints = _a.hideContentOnBreakpoints;
    return (React.createElement(Grid, { py: 5, justifyContent: FlexJustifyContent.CENTER, legacyShopRebootMaxWidth: true },
        React.createElement(GridItem, null,
            React.createElement(ShowMore, { breakpointsHide: hideContentOnBreakpoints },
                React.createElement(StyledRichTextBlock, { dangerouslySetInnerHTML: { __html: html }, "data-testid": "html" })))));
};
RichTextWithShowMore.propTypes = {
    /** HTML panel content. */
    html: PropTypes.string.isRequired,
    /** Boolean array which defines if 'Show more' feature should be used for each breakpoint. */
    hideContentOnBreakpoints: PropTypes.array,
};
export default RichTextWithShowMore;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
